export function mapArrayElement(array, mapFunction) {
    return array ? mapFunction(array) : array;
}
//# sourceMappingURL=mapArrayElement.js.map